/// <reference types="chrome" />
import { Button, Icon } from "components/ui";
import { useState } from "react";
import Logotype from "components/layout/topbar/Logotype";
import { useApi } from "hooks/api";
import { useAuth } from "hooks/auth";
import { useMutation } from "react-query";
import { OAuthToken } from "types/qbank/token";


export default function Login() {
  const { setAuth } = useAuth();
  //const { api, login } = useApi();
  const { api, loginWithCode } = useApi();
  const [logoutReason, setLogoutReason] = useState<string>("");
  const [errors, setErrors] = useState({
    host: false,
    username: false,
    password: false,
  });
  const [host, setHost] = useState(api.host);
  const [authLoading, setAuthLoading] = useState<boolean>(false);


  const { mutate: loginMutation, isLoading } = useMutation(loginWithCode, {
    onSuccess: (data: OAuthToken) => {
      setAuth({ isLoggedIn: true, oAuthToken: data });
    },
    onError: (error: any) => {
      setLogoutReason("Could not login with the given credentials");
    },
  });

  const resizeAndCenterWindow = (windowId: number, width: number, height: number) => {
    // Get the current window 
    chrome.windows.get(windowId, { populate: false }, (currentWindow) => {
      if (!currentWindow) {
        console.error('Could not get the current window.');
        return;
      }

      // Get screen dimensions of all displays(muliple display scenario)
      chrome.system.display.getInfo((displays) => {
        // Determine the display the current window is on
        const currentDisplay = displays.find(display => {
          const { left, top, width, height } = display.workArea;
          return (
            currentWindow.left! >= left &&
            currentWindow.left! < left + width &&
            currentWindow.top! >= top &&
            currentWindow.top! < top + height
          );
        });

        if (!currentDisplay) {
          console.error('Could not determine the current display.');
          return;
        }

        // Calculate center position based on the current display
        const left = Math.round(currentDisplay.workArea.left + (currentDisplay.workArea.width - width) / 2);
        const top = Math.round(currentDisplay.workArea.top + (currentDisplay.workArea.height - height) / 2);

        // Update the window size and position
        chrome.windows.update(windowId, {
          width: width,
          height: height,
          left: left,
          top: top
        }, () => {
          if (chrome.runtime.lastError) {
            console.error(chrome.runtime.lastError.message);
          }
        });
      });
    });
  }

  const resizeAuthWindowOnCreated = (width: number, height: number) => {

    chrome.windows.onCreated.addListener(function resizePopup(win) {

      if (win && win.id) {
        resizeAndCenterWindow(win.id, width, height);
        chrome.windows.onCreated.removeListener(resizePopup);
      }
    }, { windowTypes: ['popup'] })
  }

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (!host.length) {
      setErrors({
        host: !!host.length,
        username: false,
        password: false,
      });
    } else {
      localStorage.setItem("host", host);
      setErrors({
        host: false,
        username: false,
        password: false,
      });
    }
    try {
      setAuthLoading(true);
      const clientId = process.env.REACT_APP_client_id || "";
      const redirectUri = chrome.identity.getRedirectURL();
      const authUrl = `https://${host}/api/oauth2/authorize.html?client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(redirectUri)}`;

      resizeAuthWindowOnCreated(900, 680);
      chrome.identity.launchWebAuthFlow(
        { url: authUrl, interactive: true },
        function (redirectUrl) {
          if (chrome.runtime.lastError) {
            console.error(chrome.runtime.lastError);
            setLogoutReason("The authorization page could not be loaded.");
            setAuthLoading(false);
            return;
          }

          if (redirectUrl) {
            const urlParams = new URLSearchParams(new URL(redirectUrl).search);
            const authToken = urlParams.get('code');

            if (authToken) {
              loginMutation({ host, clientId, code: authToken, redirect_uri: redirectUri })
            }
            else {
              setErrors({
                host: false,
                username: false,
                password: false,
              });
            }
            setAuthLoading(false);
          }
        }
      );
    }
    catch (ex) {
      console.error(ex)
      setAuthLoading(false);
    }

  };


  return (
    <div className="connector-body">
      <div className="login-wrapper">
        <Logotype />
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          {logoutReason && <span className="bad-details">{logoutReason}</span>}
          <div className="input-group">
            <label className="label">Host</label>
            <input
              type="text"
              value={host}
              onChange={(e) => setHost(e.target.value)}
              autoFocus={true}
              required={true}
              className={errors.host ? "error" : ""}
            />
            <Icon name={"home"} />
          </div>

          <Button
            type="submit"
            loading={isLoading || authLoading}
            icon={isLoading || authLoading ? "cog" : "sign-in-alt"}
            disabled={isLoading || authLoading}
          >
            Connect
          </Button>
        </form>
      </div>
    </div>
  );
}
